import { CloseIcon } from "@/components/features/SquadBuilder/RightPanel/PanelHeader/PanelHeader";

import { TopSectionCompressed, TopSectionProps } from "./TopSection";

interface MobileScrollTopSectionProps extends TopSectionProps {
  onClose: () => void;
}
export const MobileScrollTopSection = ({
  player,
  metaRating,
  metaRatingZeroChem,
  chemistry,
  chemStyleId,
  playerRoleId,
  onClose,
}: MobileScrollTopSectionProps) => {
  return (
    <div className="flex flex-row h-full items-center justify-start gap-x-2 max-w-content mx-auto w-full pl-4">
      {player && (
        <TopSectionCompressed
          playerName={player.name}
          metaRating={metaRating}
          scrollPastTopBar={true}
          metaRatingZeroChem={metaRatingZeroChem}
          playerRoleId={playerRoleId}
          version={{
            rating: player.rating,
            metalId: player.metalId,
            versionId: player.versionId,
            resourceId: player.resourceId,
          }}
          owned={player?.owned}
        />
      )}

      {onClose && (
        <button onClick={onClose} className="absolute right-0 p-4">
          <CloseIcon />
        </button>
      )}
    </div>
  );
};
